import { useSyncExternalStore } from 'react';
import {
  AssistantActiveRouteContextEnvelopeSchema,
  type AssistantActiveRouteContextEnvelope,
} from '@triedge/domain-core';

type Listener = () => void;

let currentActiveRouteContext: AssistantActiveRouteContextEnvelope | null = null;
const listeners = new Set<Listener>();

const emit = () => {
  for (const listener of listeners) {
    listener();
  }
};

export const registerAssistantActiveRouteContext = (
  envelope: AssistantActiveRouteContextEnvelope | null,
): (() => void) => {
  const parsed = envelope
    ? AssistantActiveRouteContextEnvelopeSchema.safeParse(envelope)
    : { success: true as const, data: null };
  if (!parsed.success) {
    console.warn('[AdmissionsAI] Ignoring invalid active route context envelope', parsed.error.flatten());
    return () => undefined;
  }

  const next = parsed.data;
  currentActiveRouteContext = next;
  emit();

  return () => {
    if (currentActiveRouteContext?.contextRef === next?.contextRef) {
      currentActiveRouteContext = null;
      emit();
    }
  };
};

const subscribe = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => currentActiveRouteContext;

export const useAssistantActiveRouteContext = (): AssistantActiveRouteContextEnvelope | null =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
